import React from "react";
import { Link } from "react-router-dom";
import image_one from "../../assets/images/png/cm-yuva-yojna2.png";
import image_two from "../../assets/images/png/cm-yuva-yojna3.png";
import img8 from "../../assets/images/news/abhimanyu.jpg";
import img7 from "../../assets/images/news/akhilender.jpg";

const newsArray = [

  {
    
    image: img8,
    title: "HKI Media Partners with National Skill Development Corporation",
    desc: "HKI Media has officially partnered with the National Skill Development Corporation and Startup Stairs, reinforcing its position as a driving force in shaping the future of India’s creative economy. ",
    link: "https://businessnewsthisweek.com/business/hki-media-partners-with-national-skill-development-corporation-and-startup-stairs-to-drive-national-entrepreneurship-in-indias-creative-economy/",
  },
  {
   
    image: img7,
    title: "HKI Media has launched the upgraded Gig Media app",
    desc: "A Media-tech platform designed to connect artists, performers and creative professionals with opportunities across India’s media and entertainment sector.",
    link: "https://sunitinews.blogspot.com/2026/03/hki-media-unveils-its-media-tech.html",
  },
  {
    image: image_two,
    title: "HKI Media Partners CM Yuva Mission to Launch 500 AVGC-XR Studios Across Uttar Pradesh",
    desc: "Lucknow (UP), December 22: In a significant move to boost India’s creative economy, HKI Media has partnered with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to set up 500 AVGC-XR media studios across Uttar Pradesh, aimed at empowering youth and strengthening future-ready creative industries.",
    link: "https://aninews.in/news/business/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh20251222132855/",
  },
  {
    image: image_one,
    title: "HKI Media Joins Hands with CM Yuva Yojana, 22nd Dec 2025",
    desc: "Lucknow (UP), December 22: In a major step toward strengthening India's creative economy, HKI Media has joined hands with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to establish 500 AVGC-XR Media Studios across Uttar Pradesh.",
    link: "https://www.tribuneindia.com/news/business/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh/#:~:text=New%20Delhi%20%5BIndia%5D%2C%20December,Media%20Studios%20across%20Uttar%20Pradesh",
  },
  //   {
  //         image: image,
  //     title: "HKI Media Joins Hands with CM Yuva Yojana, 22nd Dec 2025",
  //     desc: "New Delhi [India], December 22: In a major step toward strengthening India's creative economy, HKI Media has joined hands with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to establish 500 AVGC-XR Media Studios across Uttar Pradesh.",
  //     link: "https://indiaforbesnews.in/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh/",
  //   },
  //   {
  //         image: image,
  //     title: "HKI Media Joins Hands with CM Yuva Yojana, 22nd Dec 2025",
  //     desc: "New Delhi [India], December 22: In a major step toward strengthening India's creative economy, HKI Media has joined hands with the Chief Minister Yuva Udyami Yojana (CM YUVA Mission) to establish 500 AVGC-XR Media Studios across Uttar Pradesh.",
  //     link: "https://timesofindiadaily.in/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh/",
  //   },
];

const CmYuvaNews = () => {
  return (
<section className="cmyuva_eligibility_section bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] py-5 position-relative overflow-hidden">
      {/* 2. Matches container padding exactly */}
      <div className="container py-4">
        {/* 3. Matches the inner wrapper structure exactly */}
        <div className="align-items-center g-5">
          
          {/* Header */}
          <div className="text-center mb-3" data-aos="fade-up">
             {/* Matches header margin exactly */}
            <h2 className="cmyuva_section_title m-4">Latest News</h2>
          </div>

          <div className="row align-items-start" data-aos="fade-up">
            {newsArray.map((news, index) => (
              <div
                className="col-lg-6"
                key={index}
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <div
                  // 4. Added 'mx-3' (margin-x 3) to mimic the reference code's width 
                  // and 'mb-4' for vertical spacing between rows on mobile
                  className="card h-100 mx-3 mb-4 border-0 shadow rounded-4 overflow-hidden"
                  style={{ transition: "transform 0.3s ease" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Link
                    to={news.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      loading="lazy"
                      decoding="async"
                      src={news.image}
                      alt={news.title}
                      className="card-img-top w-100"
                      style={{
                        height: "280px",
                        objectFit: "cover",
                      }}
                    />
                  </Link>
                  <div className="card-body p-4 d-flex flex-column">
                    <h3
                      className="card-title fw-semibold mb-2 text-white"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {news.title}
                    </h3>
                    <p className="card-text small text-gray-300 mb-4 flex-grow-1">
                      {news.desc}
                    </p>
                    <Link
                      to={news.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-auto text-decoration-none fw-medium small"
                      style={{ color: "#ef4444" }}
                    >
                      Read More &rarr;
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmYuvaNews;
